const isValidString = (str: string | null | undefined): str is string => !!str && str.length > 0;

const usaCountryCode = 313;
const hawaiiCountryCode = 139;

type LocationInput = {
  city?: string;
  region?: string | null;
  regionName?: string;
  country?: number | string;
  country_name?: string;
};

const getLocationName = (location: LocationInput | undefined | null) => {
  if (!location) {
    return '';
  }
  // Don't show United States or Hawaii (different country code)
  const country =
    !location.country_name ||
    location.country_name.includes('United States') ||
    location.country_name.includes('Hawaii') ||
    location.country === usaCountryCode ||
    location.country === hawaiiCountryCode
      ? ''
      : location.country_name;
  return [location.city, location.regionName || location.region, country].filter(isValidString).join(', ');
};

export default getLocationName;
